// import { Task } from "../api/API"; need to fix backend API response as per requirements once it is ready I will uncomment to use this type reference

export const getTestTaskRecords = (testRecordCount: number) => {
  const data: any[] = []; //after uncommenting above import change any to Task type

  for (let i = 1; i <= testRecordCount; i++) {
    const task = {
      taskName: `Task ${i}`,
      summary: `Summary for Task ${i}`,
      description: `This is the Task ${i}`,
      severity: i % 2 === 1 ? "high" : "low",
      dueDate: i + 1,
      tags: `Tags for Task ${i}, Tags for Task ${i + 1}, Tags for Task ${
        i + 2
      }`,
      active: i % 2 === 1 ? true : false,
      issueTitle: `Task ${i}'s issue title`,
      lastUpdated: 1705389534 + i,
      updatedBy: `Task ${i} Small`,
    };
    data.push(task);
  }

  return data;
};

// Existing task names for test
export const existingTaskNames = new Set(["existingTask1", "existingTask2"]);
